import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

export const Eliminar = (props) => {
  const {
    selectedRow,
    handleAceptDelete,
    handleCloseDelete,
    fullScreen,
    open,
  } = props;
  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleCloseDelete}
      disableBackdropClick
    >
      <DialogTitle>Eliminar difusión</DialogTitle>
      <DialogContent>
        <DialogContentText>
          ¿Esta seguro de eliminar la difusión de título{" "}
          <b>"{selectedRow && selectedRow.Titulo}"</b>?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button autoFocus color="primary" onClick={handleAceptDelete}>
          Aceptar
        </Button>
        <Button onClick={handleCloseDelete} color="primary">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default Eliminar;
